import { FaInfoCircle } from "react-icons/fa";
import { FiEdit, FiTrash2 } from "react-icons/fi";
/* ---------- TABLE CisBenchmarkFirstSeenConfig COLUMNS ---------- */
export const CISFirstSeenConfigcolumns = [
  {
    Header: "Overdue Calculation Based On",
    accessor: "overdueBasedOn",
    tdClassName: "text-center",
  },
  {
    Header: "Fields Shown In CIS Details Table",
    accessor: "cisTableFields",
    tdClassName: "text-center",
    Cell: ({ value }) => (value ? value : "-"),
  },
  {
    Header: "Updated By",
    accessor: "createdBy",
    tdClassName: "text-center",
    Cell: ({ value }) => (value ? value : "-"),
  },
  {
    Header: "Updated On",
    accessor: "createdOn",
    tdClassName: "text-center",
    Cell: ({ value }) => (value ? value : "-"),
  },
];

export const cisbenchmarkcolumns = (addInfoBodyOpen, deleteBodyOpen, addBodyOpen) => {
  const columns = [
    {
      Header: "CIS Control Type",
      accessor: "ruleName",
      id: "ruleName",
      tdClassName: "text-start",
    },
    {
      Header: "Audit File Name",
      accessor: "auditFileNames",
      id: "auditFileNames",
      tdClassName: "text-start",
      Cell: ({ value }) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {value && Array.isArray(value) && value.length > 0
            ? value.join(", ")
            : "-"}
        </div>
      ),
    },
    {
      Header: "Rules To Exclude",
      accessor: "keywords",
      id: "keywords",
      tdClassName: "text-center",
      Cell: ({ value }) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {value && Array.isArray(value) && value.length > 0
            ? value.join(", ")
            : "-"}
        </div>
      ),
    },
    {
      Header: "Actions",
      accessor: "Action",
      id: "Action",
      thClassName: "actions",
      tdClassName: "text-center",
      disableSortBy: true,
      Cell: (row) => (
        <div className="action-table">
          <div>
            <FiEdit
              className="iconStyleActions"
              title="Edit"
              onClick={() => addBodyOpen(row?.row?.original)}
              style={{ cursor: "pointer", width: "20px", height: "20px" }}
            />
          </div>
          <div>
            <FiTrash2
              className="iconStyleActions"
              title="Delete"
              onClick={() => deleteBodyOpen(row?.row?.original)}
              style={{ cursor: "pointer", width: "20px", height: "20px" }}
            />
          </div>
          <div>
            <FaInfoCircle
              className="iconStyleActions"
              onClick={() => addInfoBodyOpen(row?.row?.original)}
              title="Info"
              style={{ cursor: "pointer", width: "20px", height: "20px" }}
            />
          </div>
        </div>
      ),
    },
  ];

  return columns;
};